import React, { useEffect, useState } from "react";
import FlavorTabShimmer from "../FlavorTabShimmer";
import DragAndDropList from "./CreativesDrogAndDrop";
import { reorder } from "./CreativesNonMandatoryPromotions";

const MandatoryPromotions = ({
  loading,
  IsAdmin,
  handleDelete,
  handleEdit,
  promotionsList
}) => {
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    setItemList(promotionsList);
  }, [promotionsList]);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return; // Dragged outside the list
    }

    const updatedItems = reorder(
      itemList,
      result.source.index,
      result.destination.index
    );

    setItemList(updatedItems);
  };
  return (
    <div>
      <div className="px-6 py-4 sm:px-0">
        {loading ? (
          <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
            <FlavorTabShimmer />
          </div>
        ) : (
          <>
            {promotionsList?.length > 0 ? (
              <DragAndDropList
                promotionsList={itemList}
                handleDelete={handleDelete}
                handleEdit={handleEdit}
                dragAndDrop={true}
                type={"mandatory"}
                IsAdmin={IsAdmin}
                onDragEnd={onDragEnd}
              />
            ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "10vh",
                      fontSize: "16px",
                      color: "gray",
                    }}
                  >
                    No Promotions Available
                  </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MandatoryPromotions;
